export async function Scl90Update(
    scl90Resp,
        metaFecha,
        scl90Preg001,
        scl90Preg002,
        scl90Preg003,
        scl90Preg004,
        scl90Preg005,
        scl90Preg006,
        scl90Preg007,
        scl90Preg008,
        scl90Preg009,
        scl90Preg010,
        scl90Preg011,
        scl90Preg012,
        scl90Preg013,
        scl90Preg014,
        scl90Preg015,
        scl90Preg016,
        scl90Preg017,
        scl90Preg018,
        scl90Preg019,
        scl90Preg020,
        scl90Preg021,
        scl90Preg022,
        scl90Preg023,
        scl90Preg024,
        scl90Preg025,
        scl90Preg026,
        scl90Preg027,
        scl90Preg028,
        scl90Preg029,
        scl90Preg030,
        scl90Preg031,
        scl90Preg032,
        scl90Preg033,
        scl90Preg034,
        scl90Preg035,
        scl90Preg036,
        scl90Preg037,
        scl90Preg038,
        scl90Preg039,
        scl90Preg040,
        scl90Preg041,
        scl90Preg042,
        scl90Preg043,
        scl90Preg044,
        scl90Preg045,
        scl90Preg046,
        scl90Preg047,
        scl90Preg048,
        scl90Preg049,
        scl90Preg050,
        scl90Preg051,
        scl90Preg052,
        scl90Preg053,
        scl90Preg054,
        scl90Preg055,
        scl90Preg056,
        scl90Preg057,
        scl90Preg058,
        scl90Preg059,
        scl90Preg060,
        scl90Preg061,
        scl90Preg062,
        scl90Preg063,
        scl90Preg064,
        scl90Preg065,
        scl90Preg066,
        scl90Preg067,
        scl90Preg068,
        scl90Preg069,
        scl90Preg070,
        scl90Preg071,
        scl90Preg072,
        scl90Preg073,
        scl90Preg074,
        scl90Preg075,
        scl90Preg076,
        scl90Preg077,
        scl90Preg078,
        scl90Preg079,
        scl90Preg080,
        scl90Preg081,
        scl90Preg082,
        scl90Preg083,
        scl90Preg084,
        scl90Preg085,
        scl90Preg086,
        scl90Preg087,
        scl90Preg088,
        scl90Preg089,
        scl90Preg090,
    tratamientoId,
    pacienteId,
    scl90Id
     ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-scl90-${metaFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-scl90-${metaFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            scl90Resp: scl90Resp,
        metaFecha: metaFecha,
        scl90Preg001: scl90Preg001,
        scl90Preg002: scl90Preg002,
        scl90Preg003: scl90Preg003,
        scl90Preg004: scl90Preg004,
        scl90Preg005: scl90Preg005,
        scl90Preg006: scl90Preg006,
        scl90Preg007: scl90Preg007,
        scl90Preg008: scl90Preg008,
        scl90Preg009: scl90Preg009,
        scl90Preg010: scl90Preg010,
        scl90Preg011: scl90Preg011,
        scl90Preg012: scl90Preg012,
        scl90Preg013: scl90Preg013,
        scl90Preg014: scl90Preg014,
        scl90Preg015: scl90Preg015,
        scl90Preg016: scl90Preg016,
        scl90Preg017: scl90Preg017,
        scl90Preg018: scl90Preg018,
        scl90Preg019: scl90Preg019,
        scl90Preg020: scl90Preg020,
        scl90Preg021: scl90Preg021,
        scl90Preg022: scl90Preg022,
        scl90Preg023: scl90Preg023,
        scl90Preg024: scl90Preg024,
        scl90Preg025: scl90Preg025,
        scl90Preg026: scl90Preg026,
        scl90Preg027: scl90Preg027,
        scl90Preg028: scl90Preg028,
        scl90Preg029: scl90Preg029,
        scl90Preg030: scl90Preg030,
        scl90Preg031: scl90Preg031,
        scl90Preg032: scl90Preg032,
        scl90Preg033: scl90Preg033,
        scl90Preg034: scl90Preg034,
        scl90Preg035: scl90Preg035,
        scl90Preg036: scl90Preg036,
        scl90Preg037: scl90Preg037,
        scl90Preg038: scl90Preg038,
        scl90Preg039: scl90Preg039,
        scl90Preg040: scl90Preg040,
        scl90Preg041: scl90Preg041,
        scl90Preg042: scl90Preg042,
        scl90Preg043: scl90Preg043,
        scl90Preg044: scl90Preg044,
        scl90Preg045: scl90Preg045,
        scl90Preg046: scl90Preg046,
        scl90Preg047: scl90Preg047,
        scl90Preg048: scl90Preg048,
        scl90Preg049: scl90Preg049,
        scl90Preg050: scl90Preg050,
        scl90Preg051: scl90Preg051,
        scl90Preg052: scl90Preg052,
        scl90Preg053: scl90Preg053,
        scl90Preg054: scl90Preg054,
        scl90Preg055: scl90Preg055,
        scl90Preg056: scl90Preg056,
        scl90Preg057: scl90Preg057,
        scl90Preg058: scl90Preg058,
        scl90Preg059: scl90Preg059,
        scl90Preg060: scl90Preg060,
        scl90Preg061: scl90Preg061,
        scl90Preg062: scl90Preg062,
        scl90Preg063: scl90Preg063,
        scl90Preg064: scl90Preg064,
        scl90Preg065: scl90Preg065,
        scl90Preg066: scl90Preg066,
        scl90Preg067: scl90Preg067,
        scl90Preg068: scl90Preg068,
        scl90Preg069: scl90Preg069,
        scl90Preg070: scl90Preg070,
        scl90Preg071: scl90Preg071,
        scl90Preg072: scl90Preg072,
        scl90Preg073: scl90Preg073,
        scl90Preg074: scl90Preg074,
        scl90Preg075: scl90Preg075,
        scl90Preg076: scl90Preg076,
        scl90Preg077: scl90Preg077,
        scl90Preg078: scl90Preg078,
        scl90Preg079: scl90Preg079,
        scl90Preg080: scl90Preg080,
        scl90Preg081: scl90Preg081,
        scl90Preg082: scl90Preg082,
        scl90Preg083: scl90Preg083,
        scl90Preg084: scl90Preg084,
        scl90Preg085: scl90Preg085,
        scl90Preg086: scl90Preg086,
        scl90Preg087: scl90Preg087,
        scl90Preg088: scl90Preg088,
        scl90Preg089: scl90Preg089,
        scl90Preg090: scl90Preg090,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/scl90v/${scl90Id}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}